import CurrencyInputGroup from './CurrencyInputGroup.js';

export default CurrencyInputGroup;
